import { theme } from '@process-advisor/process-miner/shared/theme';

export const calculateYPosition = (y: number): string => {
    const maxYPosition = window.innerHeight - theme.height.colorPicker;

    return maxYPosition < y && y > theme.height.colorPicker
        ? `${y - theme.height.colorPicker - 16}px`
        : `${y + 16}px`;
};

export const calculateXPosition = (x: number): string => {
    const maxXPosition = window.innerWidth - theme.width.colorPicker;

    return maxXPosition < x && x > theme.width.colorPicker
        ? `${maxXPosition}px`
        : `${x}px`;
};
